<script>
  import { navigationStore } from "../../stores/navigationStore";
  import viewport from "../../actions/useViewport";

  import HeroBgBubbles from "./HeroBgBubbles.svelte";
  import HeroBgEl2 from "./HeroBgEl2.svelte";
  import MediaQuery from "../../components/MediaQuery.svelte";
  import BgBubblesMobile from "./Mobile/BgBubblesMobile.svelte";
  import ButtonGoogle from "./ButtonGoogle.svelte";
  import ButtonApple from "./ButtonApple.svelte";

  export let firstText = "";
  export let secondText = "";
</script>

<section
  id="home"
  use:viewport
  on:enterViewport={() => navigationStore.changeActiveItem("home")}
>
  <h1>{firstText}</h1>
  <h2>{secondText}</h2>
  <ButtonGoogle />
  <ButtonApple />

  <div class="images-wrapper">
    <div class="welcome-img">
      <img src="./assets/images/welcome.webp" alt="welcome" />
    </div>
    <div class="choose-a-goal-img">
      <img src="./assets/images/choose_a_goal.webp" alt="choose a goal" />
    </div>
  </div>

  <MediaQuery query="(max-width: 950px)" let:matches>
    <!-- Mobile -->
    {#if matches}
      <BgBubblesMobile />
    {/if}
  </MediaQuery>
  <MediaQuery query="(min-width: 951px)" let:matches>
    <!-- Desktop -->
    {#if matches}
      <HeroBgBubbles />
      <HeroBgEl2 />
    {/if}
  </MediaQuery>
</section>

<style>
  section {
    position: relative;
    width: 1440px;
    height: 720px;
    left: -32px;
    top: 80px;
  }

  h1 {
    position: absolute;
    white-space: nowrap;
    width: 285px;
    height: 65px;
    left: 122px;
    top: 250px;
    font-style: normal;
    font-weight: 900;
    font-size: 48px;
    line-height: 65px;
    text-align: center;

    color: var(--primary-color);
  }

  h2 {
    position: absolute;
    width: 268px;
    height: 36px;
    left: 126px;
    top: 331px;

    font-family: Nunito Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 150%;

    color: #6e6e6e;
  }

  button {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 74px;

    border: none;

    position: absolute;
    width: 264px;
    height: 47px;
    left: 122px;
    top: 434px;

    background-color: #5666ed;

    box-shadow: 0px 14px 24px rgba(86, 102, 237, 0.3);
    border-radius: 12px;
  }

  .welcome-img {
    position: absolute;
    width: 495px;
    left: 575px;
    top: 50px;
    filter: drop-shadow(48.9583px 48.9583px 78.3333px rgba(56, 96, 255, 0.2));

    z-index: 1;
  }

  .choose-a-goal-img {
    position: absolute;
    width: 490.69px;
    height: 589.95px;
    left: 955px;
    top: 160px;
    z-index: 1;

    filter: drop-shadow(48.9583px 48.9583px 78.3333px rgba(56, 96, 255, 0.2));
  }

  @media (max-width: 1300px) {
    /* Tablets */

    section {
      width: 100%;
      height: 760px;
      left: 0;
      top: 0;
      background-color: #e6edf6;

      display: flex;
      flex-direction: column;

      --welcome_img_top: 104px;
    }

    h1 {
      position: static;

      line-height: 55px;

      margin-top: 203px;
      margin-left: 58px;
    }

    h2 {
      position: static;

      line-height: 150%;
      text-align: center;
      margin-left: 66px;
      margin-top: 20px;
    }

    .welcome-img {
      position: relative;
      align-self: center;

      width: 360px;
      top: -175px;
      left: 455px;

      filter: drop-shadow(24.0278px 24.0278px 38.4444px rgba(56, 96, 255, 0.2));
    }

    .choose-a-goal-img {
      position: relative;

      width: 360px;

      top: -595px;
      left: 720px;

      filter: drop-shadow(24.0278px 24.0278px 38.4444px rgba(56, 96, 255, 0.2));
    }
  }

  @media (max-width: 950px) {
    /* Phones */
    section {
      width: 100%;
      height: 540px;
      left: 0;
      background-color: #e6edf6;

      display: flex;
      flex-direction: column;
      align-items: center;

      --welcome_img_top: 115px;
    }

    h1 {
      position: static;
      align-self: center;
      width: 238px;
      height: 55px;

      font-size: 40px;
      line-height: 55px;

      margin-top: 103px;
      margin-left: 0;
    }

    h2 {
      position: static;
      align-self: center;
      height: 30px;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 150%;
      text-align: center;

      margin-top: 20px;
      margin-left: 0;
    }

    .welcome-img {
      position: relative;
      left: -56px;
      top: var(--welcome_img_top);

      width: calc(240px);

      filter: drop-shadow(24.0278px 24.0278px 38.4444px rgba(56, 96, 255, 0.2));
    }

    .choose-a-goal-img {
      position: relative;
      top: -152px;
      left: 103px;
      margin-left: 16px;

      width: 240px;
      height: 240px;

      filter: drop-shadow(24.0278px 24.0278px 38.4444px rgba(56, 96, 255, 0.2));
    }
  }
</style>
